import {
  CreateSupportNoteRequest,
  FetchSupportNotesParams,
  SupportNote,
  SupportNoteListResponse,
} from '../stores/types/supportnote.interface';
import { API_KEYS, Api } from './base.api';
import { SCOPE_TYPE } from './utils';

const SUPPORT_NOTE_PATH = '/internal/core/v2/supportnotes';

export const supportnoteApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchSupportNotes: builder.query<SupportNoteListResponse, FetchSupportNotesParams>({
      query: (params) => ({
        url: SUPPORT_NOTE_PATH,
        params: {
          scope: SCOPE_TYPE.NONE,
          ...params,
        },
        method: 'GET',
        needCompanyId: false,
      }),
      providesTags: [{ type: API_KEYS.SUPPORT_NOTE, id: 'LIST' }],
    }),
    createSupportNote: builder.mutation<SupportNote, CreateSupportNoteRequest>({
      query: (body) => ({
        url: SUPPORT_NOTE_PATH,
        params: {
          scope: SCOPE_TYPE.NONE,
        },
        method: 'POST',
        body,
        needCompanyId: false,
      }),
      invalidatesTags: [{ type: API_KEYS.SUPPORT_NOTE, id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchSupportNotesQuery,
  useLazyFetchSupportNotesQuery,
  useCreateSupportNoteMutation,
} = supportnoteApi;
